import { AdminRouteName } from '../../../CONSTANTS';
import RentCollectionTableRecords from '../RentCollectionTableRecords';

const optionalColumn = [
  'dateActioned',
];

const optionalColumnLabelFormat = {
  dateActioned: 'Date Actioned',
};

const AllRentCollection = () => (
  <RentCollectionTableRecords
    optionalColumn={optionalColumn}
    optionalColumnLabelFormat={optionalColumnLabelFormat}
    defaultUrl={AdminRouteName.rentCollectionRoute}
    toggleStorageId="settled_rent-collection-table-col"
    hasNameAndImage
    permissionName="can-view-rent-payment"
  />
);
export default AllRentCollection;
